import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
    theme: {
        info: '#2B65F0',
        primary: '#424E55',
        secondary: '#b0bec5',
        accent: '#8c9eff',
        error: '#D0021B'
    }
}

export default new Vuetify(opts)
